<template>
  <el-dialog
    title="交易对设置"
    width="1000px"
    :visible="detailDialogVisible"
    @close="closeDialog"
  >
    <el-form
      :model="detailForm"
      ref="detailForm"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item label="交易对：" prop="pair">
        <el-input v-model="detailForm.pair" disabled width="100px"></el-input>
      </el-form-item>

      <el-form-item label="价格精度：" prop="defaultPrecision">
        <el-input-number
          v-model="detailForm.defaultPrecision"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="数量精度：" prop="amountPrecision">
        <el-input-number
          v-model="detailForm.amountPrecision"
          :min="0"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="是否展示：" prop="shouldDisplay">
        <el-switch
          v-model="detailForm.shouldDisplay"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>

      <el-form-item label="是否支持交易：" prop="supportTrade">
        <el-switch
          v-model="detailForm.supportTrade"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>

      <el-form-item label="是否支持下买单：" prop="supportBid">
        <el-switch
          v-model="detailForm.supportBid"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>

      <el-form-item label="最早买单时间：" prop="earliestBidTime">
        <el-date-picker
          v-model="detailForm.earliestBidTime"
          type="datetime"
          placeholder="选择最早买单时间"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="是否支持下卖单：" prop="supportAsk">
        <el-switch
          v-model="detailForm.supportAsk"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>

      <el-form-item label="最早卖单时间：">
        <el-date-picker
          v-model="detailForm.earliestAskTime"
          type="datetime"
          placeholder="选择最早卖单时间"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="是否风险系数高:" prop="highRisk">
        <el-switch
          v-model="detailForm.highRisk"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>
      <el-form-item label="交易买费率:">
        <el-input v-model="detailForm.bidFeeRate" />
      </el-form-item>
      <el-form-item label="交易卖费率:">
        <el-input v-model="detailForm.askFeeRate" />
      </el-form-item>
      <el-form-item label="最小交易额:">
        <el-input v-model="detailForm.minimumTradeVolume" />
      </el-form-item>
      <el-form-item label="上线时间：">
        <el-date-picker
          v-model="detailForm.onlineTime"
          type="datetime"
          placeholder="选择上线时间"
        ></el-date-picker>
        <p style="color: #999">(备注：用于显示计算倒计时时间，不代表真实上线时间)</p>
      </el-form-item>
      <el-form-item
        label="真实上线时间(运营勿动!):"
        prop="realOnlineTime"
        class="realkline-wrap"
      >
        <el-date-picker
          v-model="detailForm.realOnlineTime"
          type="datetime"
          placeholder="真实上线时间(运营勿动!)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="是否属于期货">
        <el-switch
          v-model="detailForm.futures"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>
      <el-form-item v-if="detailForm.futures" label="期货兑换开始时间">
        <el-date-picker
          v-model="detailForm.beginTime"
          type="datetime"
          placeholder="期货兑换开始时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-if="detailForm.futures" label="期货详情网址">
        <el-input v-model="detailForm.websiteUrl"></el-input>
      </el-form-item>

      <el-form-item label="交易区" prop="tradeSet">
        <el-select
          v-model="detailForm.tradeSet"
          placeholder="请选择"
          @change="selectSubList"
        >
          <el-option
            v-for="item in fristList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子交易区">
        <el-select
          v-model="detailForm.subTradeSet"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in subList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Icon 中文">
        <upload
          v-model="detailForm.iconZh"
          :data="{ language: 1, platform: 1 }"
        ></upload>
      </el-form-item>
      <el-form-item label="Icon 中文描述">
        <el-input v-model="detailForm.descZh"></el-input>
      </el-form-item>
      <el-form-item label="Icon 英文">
        <upload
          v-model="detailForm.iconEn"
          :data="{ language: 4, platform: 1 }"
        ></upload>
      </el-form-item>
      <el-form-item label="Icon 英文描述">
        <el-input v-model="detailForm.descEn"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('detailForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import upload from "../../../../../components/upload";
import api from "../../api";

export default {
  name: "TradePairDetail",
  components: { upload },
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      earliestBidTime: "",
      earliestAskTime: "",
      realOnlineTime: "",
      onlineTime: "",
      detailForm: {
        tradeRangeList: [],
      },
      rules: {},
      virtualSets: [],
      allList: [],
      fristList: [],
      subList: [],
    };
  },
  computed: {
    ...mapState("tradePairSetting", [
      "detailDialogVisible",
      "pairConfigDetail",
      "virtualTradeSet",
    ]),
    ...mapState("tradeRange", ["totalCount", "tradeRangeList"]),
  },
  mounted() {
    this.queryTradeRangeList();
  },
  methods: {
    ...mapMutations("tradePairSetting", [
      "toggleDetailDialogVisible",
      "setPairConfigDetail",
    ]),
    ...mapActions("tradePairSetting", ["update", "updateTradePair"]),
    ...mapActions("tradeRange", ["findTradeRangeList"]),
    closeDialog() {
      this.$refs.detailForm.resetFields();
      if (this.detailForm.tradeSet == localStorage.getItem("tradeSet")) {
        this.detailForm.subTradeSet = localStorage.getItem("subTradeSet").split(",");
      } else {
        this.detailForm.subTradeSet = [];
      }
      this.toggleDetailDialogVisible(false);
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let subData = { ...this.detailForm };
          subData.earliestBidTime &&
            subData.earliestBidTime.getTime &&
            (subData.earliestBidTime = subData.earliestBidTime.getTime());
          subData.earliestAskTime &&
            subData.earliestAskTime.getTime &&
            (subData.earliestAskTime = subData.earliestAskTime.getTime());
          subData.realOnlineTime &&
            subData.realOnlineTime.getTime &&
            (subData.realOnlineTime = subData.realOnlineTime.getTime());
          if (subData.onlineTime) {
            subData.onlineTime &&
              subData.onlineTime.getTime &&
              (subData.onlineTime = subData.onlineTime.getTime());
          }
          if (subData.futures) {
            try {
              subData.beginTime &&
                subData.beginTime.getTime &&
                (subData.beginTime = subData.beginTime.getTime());
            } catch (e) {
              console.log(e);
              console.log(subData.beginTime);
            }
          } else {
            subData.beginTime = 0;
            subData.websiteUrl = "";
          }
          if (subData.futures && subData.beginTime === null) {
            this.$message.error("期货兑换开始时间不能为空");
            return;
          }
          subData.supportVirtualSets = "";
          for (let index in this.virtualSets) {
            subData.supportVirtualSets =
              subData.supportVirtualSets + this.virtualSets[index] + ",";
          }
          if (subData.subTradeSet) {
            subData.subTradeSet = subData.subTradeSet.toString();
          } else {
            subData.subTradeSet = [];
          }
          this.updateTradePair({ ...subData }).then(() => {
            this.$message.success("修改成功！");
            this.toggleDetailDialogVisible(false);
            this.virtualSets = [];
            subData.supportVirtualSets = "";
            localStorage.removeItem("tradeSet")
            localStorage.removeItem("subTradeSet")
            this.$emit("refresh");
          });
        }
      });
    },
    queryTradeRangeList() {
      api.listTradeRange({ page: 1, size: 999 }).then((res) => {
        this.allList = res.data;
        res.data.forEach((item) => {
          if (item.level == 1) {
            this.fristList.push(item);
          } else if (item.level == 2) {
            this.subList.push(item);
          }
        });
      });
    },
    selectSubList(val) {
      this.subList = [];
      this.detailForm.subTradeSet = [];
      this.allList.forEach((item) => {
        if (item.supCode == val) {
          this.subList.push(item);
        }
      });
      if (this.detailForm.tradeSet == localStorage.getItem("tradeSet")) {
        this.detailForm.subTradeSet = localStorage.getItem("subTradeSet").split(",");
      } else {
        this.detailForm.subTradeSet = [];
      }
    },
  },
  watch: {
    pairConfigDetail(newVal, oldVal) {
      this.detailForm = { ...newVal };
      localStorage.setItem("tradeSet", newVal.tradeSet);
      localStorage.setItem("subTradeSet", newVal.subTradeSet);
      this.subList = [];
      if (this.detailForm.tradeSet != "") {
        this.allList.forEach((item) => {
          if (item.supCode == this.detailForm.tradeSet) {
            this.subList.push(item);
          }
        });
      }
      if (this.detailForm.subTradeSet) {
        this.detailForm.subTradeSet = this.detailForm.subTradeSet.split(",");
      } else {
        this.detailForm.subTradeSet = [];
      }
      if (newVal.supportVirtualSets) {
        this.virtualSets = newVal.supportVirtualSets;
      } else {
        this.virtualSets = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.realkline-wrap {
  padding-top: 22px;
  border-top: 1px solid #ededed;
}
</style>
